/**
 * Absolute URL of a file in b2b-demo's `public/`, for images the widget loads
 * at run time instead of carrying them inside the bundle (#1469).
 *
 * The widget is a Vite library build, and library builds inline every imported
 * image as base64: the Andys hero photo alone was 2.2 MB of the 4.5 MB bundle,
 * and every phone had to download and parse it before the landing could show.
 *
 * On a dealer's site a root-relative path would resolve against the dealer's
 * domain, so the path is resolved against the bundle's own script URL, taken
 * while the bundle runs (`document.currentScript` is gone after that). The
 * standalone app, the dev server and Storybook load modules, which have no
 * current script; they serve `public/` under the Vite base (`/`, or the
 * Storybook portal's subpath) and get `<base><path>`.
 */
const SCRIPT_SRC =
  typeof document !== 'undefined' && document.currentScript?.src ? document.currentScript.src : null;

const VITE_BASE = import.meta.env.BASE_URL || '/';

/**
 * @param {string} path - path inside `public/`, e.g. `assets/landing/andys-hero.webp`
 * @param {string|null} [scriptSrc] - the widget bundle's URL (tests pass their own)
 * @param {string} [base] - the Vite base for builds without a bundle script
 * @returns {string}
 */
export function widgetAssetUrl(path, scriptSrc = SCRIPT_SRC, base = VITE_BASE) {
  const relative = String(path).replace(/^\/+/, '');
  if (scriptSrc) {
    try {
      return new URL(relative, scriptSrc).href;
    } catch {
      // Not a parseable URL — fall back to the base-relative path.
    }
  }
  return `${base.endsWith('/') ? base : `${base}/`}${relative}`;
}
